<template>
	<sacleBox>
		<div class="appconten">
			<div class="appleft">
				<div class="applefttitle">
					<p class="lefttitilefonts">// 累计实训时长数据 //</p>
					<p class="fontsanum"><numbergrow :value="alltrainsnumobj.trainTime"></numbergrow></p>
				</div>

				<div class="appleftcenter">
					<img src="../../images/datetoptitle.png" alt="" />
					<p class="appleftfonts">个人实训排行榜</p>
				</div>
				<div class="trainsb monitor">
					<ul>
						<li>
							<p style="background-color: transparent;">排名</p>
							<p>姓名</p>
							<p>学习时长（小时）</p>
							<p>综合能力</p>
						</li>
					</ul>
					<div style="overflow: hidden;" @click="handleClick($event)">
						<vueSeamlessScroll v-if="userslist.length > 0" :data="userslist" class="seamless-warp" :class-option="classOption">
							<ul>
								<li class="listItem" v-for="(item, index) in userslist" :key="index">
									<p :data-dept="item.ui_guid">{{ index + 1 }}</p>
									<p style="cursor: pointer;" :data-dept="item.ui_guid">{{ item.ui_realName }}</p>
									<p :data-dept="item.ui_guid">{{ item.LengthOfTimeSeconds }}</p>
									<p :data-dept="item.ui_guid" style="display: flex;align-items: center;justify-content: center;">
										<img v-for="(strat, stratidx) in item.Count" :key="stratidx" style="width: 20px;height: 20px;" src="../../assets/strat.svg" alt="" />
									</p>
								</li>
							</ul>
						</vueSeamlessScroll>
					</div>
				</div>

				<div class="appleftcenter">
					<img src="../../images/datetoptitle.png" alt="" />
					<p class="appleftfonts">班级实训排行榜</p>
				</div>
				<div class="trainsb monitor">
					<ul>
						<li>
							<p style="background-color: transparent;">排名</p>
							<p style="width:45%;">班级名称</p>
							<p style="width:30%;">累计时长（小时）</p>
							<p style="width:15%;">合格率</p>
						</li>
					</ul>
					<div style="overflow: hidden;">
						<vueSeamlessScroll v-if="appointmentlist.length > 0" :data="appointmentlist" class="seamless-warp" :class-option="classOption1">
							<ul>
								<li v-for="(item, index) in appointmentlist" :key="index">
									<p style="width: 5%;">{{ index + 1 }}</p>
									<!-- margin-right: 5px; -->
									<p style="width:60%;" :title="item.cla_name">{{ item.cla_name }}</p>
									<p style="width:30%;">{{ item.LengthOfTimeSeconds }}</p>
									<p style="width:10%;display: flex;align-items: center;justify-content: center;">
										<span>{{ item.pPercent }}%</span>
									</p>
								</li>
							</ul>
						</vueSeamlessScroll>
					</div>
				</div>

				<div style="width: 100%;height: 25%;">
					<div class="appleftcenter">
						<img src="../../images/datetoptitle.png" alt="" />
						<p class="appleftfonts">本周实训人数统计</p>
					</div>
					<div class="nomolflex trainspic3" id="pic4"></div>
				</div>
			</div>
			<img src="../../images/chartline.png" class="lines" alt="这是一条线" />
			<div class="appcenter">
				<div class="trainstitle">
					<img src="../../images/datetopbgg.png" alt="" />
					<p>As型地铁仿真驾驶实训管理平台</p>
				</div>
				<div class="trainsweather nomolflex">
					<div class="trainsbox">
						<div class="trainsboxleft">
							<p>{{ nowTime }}</p>
							<p style="padding-left: 10px;">{{ yeartimer }}</p>
						</div>

						<!-- <div class="trainsboxright">
							<img style="width: 40%;" v-if="weatherobj.weatherimg" :src="weatherobj.weatherimg" alt="" />
							<p class="comenteflex" style="margin-left: 24px; color: rgb(205, 221, 247);">
								<span>{{ weatherobj.weather }}</span>
								<span>{{ weatherobj.temperature }}℃</span>
								<span>{{ autolocation.city }}</span>
							</p>
						</div> -->
					</div>
					<img class="dataline" src="../../images/dataline.png" alt="" />
					<div class="trainsall">
						<!-- <p>实训室总数：{{ alltrainsnumobj.trainCount }} 个</p> -->
						<!-- {{ alltrainsnumobj.trainECount }} -->
						<p style="color: #7FFF00;">实训设备总数： 8 套</p>
						<p style="color: #7FFFD4;">实训人数：{{ alltrainsnumobj.trainPCount }} 人</p>
					</div>
				</div>
				<div class="nomolflex trainsimg"><div class="nomolflex trainspic2" id="pic2"></div></div>
			</div>
			<img src="../../images/chartline.png" class="lines" alt="这是一条线" />
			<div class="appright">
				<div style="width: 100%;height: 26%;margin-bottom: 10px;">
					<div class="appleftcenter">
						<img src="../../images/datetoptitle.png" alt="" />
						<p class="appleftfonts">设备使用率分析</p>
					</div>
					<div class="nomolflex trainspic3" id="pic3"></div>
				</div>

				<div class="appleftcenter">
					<img src="../../images/datetoptitle.png" alt="" />
					<p class="appleftfonts">实训设备状态分析</p>
				</div>

				<div class="applefecharts"><div class="echartsa" id="pic1" ref="pic1"></div></div>

				<div style="width: 100%;height: 50%;">
					<div class="appleftcenter">
						<img src="../../images/datetoptitle.png" alt="" />
						<p class="appleftfonts">实时预约数据</p>
					</div>
					<div class="traingety">
						<ul>
							<li class="nomolflex">
								<p>姓名</p>
								<p>预约设备</p>
								<p>实训时间</p>
							</li>
						</ul>

						<div style="overflow: hidden;" class="scrols" @click="handleClick($event)">
							<vueSeamlessScroll v-if="appoindatalist.length > 0" :data="appoindatalist" class="seamless-warp" :class-option="classOption3">
								<ul style="margin-top: 0;">
									<li class="nomolflex listItem" v-for="(item, index) in appoindatalist" :key="index" :data="JSON.stringify(item)">
										<p :data-dept="item.ui_guid">{{ item.ui_realName }}</p>
										<p :data-dept="item.ui_guid">{{ item.tr_name }}({{ item.te_deviceName }})</p>
										<p :data-dept="item.ui_guid">{{ item.ap_appDate }}</p>
									</li>
								</ul>
							</vueSeamlessScroll>
						</div>
					</div>
				</div>
			</div>
		</div>
	</sacleBox>
</template>

<script>
import AppOptions from '@/config/AppOptions.vue';

import 'echarts/lib/chart/bar';
import vueSeamlessScroll from 'vue-seamless-scroll';
import numbergrow from '@/components/numberdt/numbergrow.vue';
import $ from 'jquery';
import {
	DataWallGetTrainSTA, //实训统计数据
	GetTrainSTANewAPI, // 新实训统计数据
	DataWallGetTrainCount, // 获取本周实训人数统计
	GetTrainCountNewCountApi, // 新获取本周实训人数统计
	GetTrainEquipmentStatusSTA,
	GetTrainUsageSTA,
	GetTrainSingleDataList, // 个人实训排行榜
	GetTrainSingleDataListNewApi, // 新个人实训排行榜
	GetTrainSingleDataListNewCQApi, // 个人实训排行榜模拟驾驶
	GetTrainClassDataList, // 班级实训
	GetTrainClassDataListNewAPi, // 新班级实训排行榜
	GetPageAppointDataList,
	GetTrainTimeLengthDataList, //设备实训时长统计
	GetTrainTimeLengthDataListNewApi, // 新设备实训时长统计
	TrainingequipmentTimeApi, // 新设备实训时长统计
	GetDatasyncApi //检测同步数据
} from '@/request/alllog.js';
$('.appconten').outerHeight($(document).outerHeight());
$('.appright').outerHeight($(document).outerHeight());

import sacleBox from '@/components/sacleBox.vue';

export default {
	data() {
		return {
			weatherobj: {},
			dataMap: {},
			myCharts2: {},
			myCharts3: {},
			myCharts4: {},
			listLenght: 6,
			userslist: [],
			appointmentlist: [],

			// 时间
			timer: '', //定义一个定时器
			usertimers: '',
			nowTime: '',
			yeartimer: '',
			years: new Date().getFullYear(),
			option1: {
				legend: {
					show: true,
					right: '10%',
					orient: 'vertical',
					bottom: '30%',
					textStyle: {
						color: '#fff'
					},
					formatter: (val, idx) => {
						// console.log(val, '获取');
						// var htmls = '';
						// if (val === '维修中') {
						// 	htmls =
						// 		'<p style=color:#fff;><span style="margin-right: 5px;border-radius: 5px; display: block;width: 40px;height: 20px;background-color: #EE6666;"></span>' +
						// 			val +
						// 			'<span style="color: #EE6666;margi:0 10px;">' +
						// 			this.allstatussta.OfflineCount ??
						// 		'' + '</span>台' + this.allstatussta.OfflineCountUsage ??
						// 		'' + '%</p>';
						// }
						return val;
					}
				},
				tooltip: {
					show: true,
					trigger: 'item',
					formatter: '{a} <br/>{b}: {c} ({d}%)'
				},
				series: [
					{
						name: '实时设备状态统计',
						type: 'pie',
						radius: ['40%', '90%'],
						center: ['40%', '50%'],
						avoidLabelOverlap: true,
						label: {
							show: false,
							position: 'center',
							formatter: val => {
								// console.log(val,'获取图标信息')
								return val.name;
							}
						},
						emphasis: {
							label: {
								show: true,
								fontSize: '18',
								fontWeight: 'bold'
							}
						},
						labelLine: {
							show: false
						},
						data: [
							{
								value: 1500,
								name: '维修中',
								itemStyle: {
									color: '#EE6666'
								}
							},
							{
								value: 742,
								name: '空闲中',
								itemStyle: {
									color: '#5470C6'
								}
							},
							{
								value: 1000,
								name: '离线中',
								itemStyle: {
									color: '#FAC858'
								}
							},
							{
								value: 2721,
								name: '使用中',
								itemStyle: {
									color: '#91CC75'
								}
							}
						]
					}
				]
			},
			myCharts1: {},
			optionsb3: {},
			optionsb1: {
				tooltip: {
					trigger: 'item'
				},
				legend: {
					orient: 'vertical',
					left: '4%',
					top: '20%',
					textStyle: {
						color: '#fff'
					}
				},
				series: [
					{
						name: '设备使用情况分析',
						type: 'pie',
						radius: '75%',
						left: 'center',
						avoidLabelOverlap: false,
						center: ['65%', '55%'],
						label: {
							show: true,
							position: 'outside',
							formatter: '{b} {d}%({c})',
							textStyle: {
								fontSize: '12',
								fontWeight: '400',
								color: '#fff'
							},
							emphasis: {
								show: true,
								textStyle: {
									fontSize: '16',
									fontWeight: '400',
									color: '#fff'
								}
							}
						},
						labelLine: {
							show: true,
							length: 5,
							length2: 5
						},
						color: ['#91CC75', '#5470C6'],
						data: [
							{
								value: 0,
								name: '空闲'
							},
							{
								value: 10,
								name: '使用中'
							}
						],
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}
				]
			},
			optionsb2: {
				baseOption: {
					timeline: {
						axisType: 'category',
						loop: true,
						autoPlay: true,
						playInterval: 3000,
						data: ['2024'],
						bottom: 20,
						grid: {
							bottom: 100
						},
						label: {
							textStyle: {
								color: '#fff'
							},
							formatter: function(s) {
								return new Date(s).getFullYear();
							}
						}
					},
					title: {
						subtext: '数据来自As型地铁仿真驾驶实训管理平台',
						subtextStyle: {
							color: '#999',
							fontSize: 14
						}
					},
					tooltip: {},
					legend: {
						show: false,
						left: 'right',
						data: []
					},
					calculable: true,
					grid: {
						top: 100,
						bottom: 120,
						left: 60,
						right: 10,
						tooltip: {
							trigger: 'axis',
							axisPointer: {
								type: 'shadow',
								label: {
									show: true,
									formatter: function(params) {
										return params.value;
									}
								}
							}
						}
					},
					xAxis: [
						{
							type: 'category',
							axisLabel: {
								interval: 0,
								textStyle: {
									color: '#fff',
									fontSize: 18
								}
							},
							data: ['模拟驾驶台1', '模拟驾驶台2', '模拟驾驶台3', '模拟驾驶台4', '模拟驾驶台5', '模拟驾驶台6', '模拟驾驶台7', '模拟驾驶台8'],
							/*
							'模拟驾驶台9',
							'模拟驾驶台10'
							 */

							splitLine: {
								show: false
							},
							animationDuration: 300,
							animationDurationUpdate: 300
						}
					],
					yAxis: [
						{
							type: 'value',
							name: '时长（小时）',

							nameTextStyle: {
								color: '#fff'
							},
							axisLabel: {
								interval: 0,
								textStyle: {
									color: '#fff',
									fontSize: 18
								}
							}
						}
					],
					series: [
						{
							name: '实训时长',
							type: 'bar',
							label: {
								show: true,
								position: 'top', // 标签的位置，可选值有 'top'、'left'、'right'、'bottom'、'inside'、'insideTop'、'insideLeft'、'insideRight'、'insideBottom'、'insideTopLeft'、'insideBottomLeft'、'insideTopRight'、'insideBottomRight'
								formatter: '{c}', // 格式化标签内容，'{c}' 表示当前数据值
								fontSize: 16
							}
						}
					]
				},
				options: [
					{
						title: {
							text: '2024年设备实训时长统计',
							textStyle: {
								color: '#fff',
								fontSize: 24
							},
							left: '5%'
						},
						series: [
							{
								realtimeSort: true,
								data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
								encode: {
									x: 0, //指的是：cdata
									y: 3 //指的是：ccut,
								},
								itemStyle: {
									color: function(params) {
										var colorList = ['#c23531', '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3'];
										return colorList[params.dataIndex % colorList.length];
									}
								}
							}
						]
					}
				]
			},

			options3: {
				grid: {
					top: '20%',
					left: '2%',
					right: '2%',
					bottom: '10%',
					containLabel: true
				},
				xAxis: {
					type: 'category',
					data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
					axisLabel: {
						show: true,
						textStyle: {
							color: '#FADB71'
						}
					}
				},
				yAxis: {
					type: 'value',
					// name: '单位（人）',
					axisLabel: {
						show: true,
						textStyle: {
							color: '#FADB71'
						},
						formatter: '{value} 人'
					},
					splitLine: {
						//网格线
						lineStyle: {
							type: 'dashed' //设置网格线类型 dotted：虚线 solid:实线
						},
						show: true //隐藏或显示
					},
					min: 0, // 起始
					max: 0 // 终止
				},

				series: [
					{
						data: [],
						type: 'bar',
						color: '#FADB71',
						label: {
							//数值显示
							show: true, //显示柱状图上每一列的数值
							rotate: 20, //让显示的数值进行旋转
							position: 'inside', //标签的位置
							textStyle: {
								color: '#000'
							}
						},

						emphasis: {
							focus: 'series', // 在高亮图形时，是否淡出其它数据的图形已达到聚焦的效果。默认值'none'不淡出其它图形，series' 聚焦当前高亮的数据所在的系列的所有图形，'self' 只聚焦（不淡出）当前高亮的数据的图形
							label: {
								show: true
							}
						}
					}
				]
			},
			siguids: '',
			alltrainsnumobj: {},
			allstatussta: {},
			autolocation: {},
			appoindatalist: [],
			pageSize: 20,
			allistyears: '',
			dataname: [],
			datayearname: [],
			serieslist: [],
			serieslistdata: [],
			isdatascheck: 0,
			timera1: null
		};
	},
	watch: {
		allistyears(val) {
			if (val == '') {
				this.getlistyears();
			}
		}
	},
	beforeCreate() {
		AppOptions.appEmpty = true;
	},
	created() {},
	mounted() {
		document.title = '实训室管理平台';

		this.siguids = this.$route.query.siguid;
		this.charts();

		this.getlistyears(); // 使用时长分析

		this.timera1 = setInterval(async () => {
			let isdatasync = await GetDatasyncApi('');
			console.log(isdatasync.data.data != this.isdatascheck, '获取更新值');
			if (isdatasync.data.data != this.isdatascheck) {
				this.getlistyears();
			}
		}, 8000);

		this.getTime(); // 获取时间
		// 再dom生产之后再产生数据
		this.$nextTick(() => {
			this.getsingledata(); // 获取滚动
			this.gettarinclas();
			this.getdatalist();
		});
		this.gettrainsta();
		this.gettraincount();
		this.gettraaineqstatus();
		this.changescharts3();
	},
	computed: {
		classOption1() {
			return {
				step: 0.2, // 数值越大速度滚动越快
				limitMoveNum: this.appointmentlist.length, // 开始无缝滚动的数据量 this.dataList.length
				hoverStop: true, // 是否开启鼠标悬停stop
				direction: 1, // 0向下 1向上 2向左 3向右
				openWatch: true, // 开启数据实时监控刷新dom
				singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
				singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
				waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
			};
		},
		classOption() {
			return {
				step: 0.2, // 数值越大速度滚动越快
				limitMoveNum: this.userslist.length, // 开始无缝滚动的数据量 this.dataList.length
				hoverStop: true, // 是否开启鼠标悬停stop
				direction: 1, // 0向下 1向上 2向左 3向右
				openWatch: true, // 开启数据实时监控刷新dom
				singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
				singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
				waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
			};
		},
		classOption3() {
			return {
				step: 0.1, // 数值越大速度滚动越快
				limitMoveNum: this.appoindatalist.length, // 开始无缝滚动的数据量 this.dataList.length
				hoverStop: true, // 是否开启鼠标悬停stop
				direction: 1, // 0向下 1向上 2向左 3向右
				openWatch: true, // 开启数据实时监控刷新dom
				singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
				singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
				waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
			};
		}
	},

	methods: {
		gouserdata(val) {
			console.log(val);
			if (!val.ui_guid && !val.cla_guid) {
				return;
			}

			let routerquery = {
				siguid: this.$route.query.siguid,
				cla_guid: val.cla_guid,
				ui_guid: val.ui_guid
			};
			this.$router.push({
				path: '/datawall/driveschooldatauser',
				query: routerquery
			});
		},

		charts() {
			let myCharts1 = this.$echarts.getInstanceByDom(document.getElementById('pic1'));
			// console.log(myCharts1,"charts1")
			if (myCharts1 == null) {
				myCharts1 = this.$echarts.init(document.getElementById('pic1'));
			}
			this.myCharts1 = myCharts1;
			myCharts1.setOption(this.option1);
			// 中间图表信息
			let myCharts2 = this.$echarts.getInstanceByDom(document.getElementById('pic2'));
			if (myCharts2 == null) {
				myCharts2 = this.$echarts.init(document.getElementById('pic2'));
			}
			this.myCharts2 = myCharts2;
			// 设备使用率分析
			let myCharts3 = this.$echarts.getInstanceByDom(document.getElementById('pic3'));
			if (myCharts3 == null) {
				myCharts3 = this.$echarts.init(document.getElementById('pic3'));
			}
			myCharts3.setOption(this.optionsb1);
			this.myCharts3 = myCharts3;

			let myCharts4 = this.$echarts.getInstanceByDom(document.getElementById('pic4'));
			if (myCharts4 == null) {
				myCharts4 = this.$echarts.init(document.getElementById('pic4'));
			}
			myCharts4.setOption(this.options3);
			this.myCharts4 = myCharts4;
			window.addEventListener('resize', function() {
				myCharts1.resize();
				myCharts2.resize();
				myCharts3.resize();
				myCharts4.resize();
			});
		},
		handleClick(e) {
			// console.log(e.target.dataset, '获取信息dom', e.currentTarget.dataset.dept);
			var userguid = e.target.dataset.dept;
			// console.log(e.target.dataset);
			if (userguid) {
				var valobj = this.userslist.find(item => item.ui_guid == userguid);
				// console.log(valobj, '获取信息fid');
				this.gouserdata(valobj);
			}
		},
		getdatalist() {
			let appontobj = {
				pageIndex: 1,
				pageSize: this.pageSize,
				si_guid: this.siguids
			};
			let timer = null;
			GetPageAppointDataList(appontobj).then(res => {
				// console.log(res)
				if (res) {
					this.appoindatalist = res.data.data.list;
				} else {
				}
			});
		},

		gettarinclas() {
			let timer = null;
			// GetTrainClassDataList(this.siguids).then(res => {
			GetTrainClassDataListNewAPi(this.siguids).then(res => {
				// console.log(res)
				if (res) {
					this.appointmentlist = res.data.data;
				} else {
				}
			});
		},

		getsingledata() {
			let timer = null;
			// GetTrainSingleDataList(this.siguids).then(res => {
			// GetTrainSingleDataListNewApi(this.siguids).then(res => {
			GetTrainSingleDataListNewCQApi(this.siguids).then(res => {
				// console.log(res)
				if (res) {
					this.userslist = res.data.data;
				} else {
				}
			});
		},
		gettraaineqstatus() {
			let timer = null;
			GetTrainEquipmentStatusSTA(this.siguids).then(res => {
				// 设备使用状态
				if (res) {
					this.allstatussta = res.data.data;
					this.option1.series[0].data[0].value = res.data.data.OfflineCount;
					this.option1.series[0].data[1].value = res.data.data.IdleCount;
					this.option1.series[0].data[2].value = res.data.data.RepairCount;
					this.option1.series[0].data[3].value = res.data.data.UsingCount;
					// console.log(this.allstatussta,"设备状态")
					this.myCharts1.setOption(this.option1);

					// timer = setTimeout(() => {
					// 	this.gettraaineqstatus();
					// }, 1800000); //30分钟查一下
				} else {
					// clearTimeout(timer); //清理定时任务
				}
			});
		},
		gettraincount() {
			// console.log(new Date().getFullYear() + "/"+(new Date().getMonth()+1)+"/"+new Date().getDate())
			let timers = new Date().getFullYear() + '/' + (new Date().getMonth() + 1) + '/' + new Date().getDate();
			let countobj = {
				si_guid: this.siguids,
				time: timers
			};
			let timer = null;
			// DataWallGetTrainCount(countobj).then(res => {
			GetTrainCountNewCountApi(countobj).then(res => {
				// console.log(res)
				let datelist = [];
				let countlist = [];
				if (res) {
					res.data.data.forEach(item => {
						datelist.push(item.date);
						countlist.push(item.count);
					});
					let maxs = Math.max(...countlist);
					// console.log(maxs, '最大值');
					this.options3.yAxis.max = maxs + 3;

					this.options3.xAxis.data = datelist;
					this.options3.series[0].data = countlist;
					this.myCharts4.setOption(this.options3);
					// timer = setTimeout(() => {
					// 	this.gettraincount();
					// }, 1800000); //2秒查一下
				} else {
					// clearTimeout(timer); //清理定时任务
				}
			});
		},
		gettrainsta() {
			let timer = null;
			// DataWallGetTrainSTA(this.siguids).then(res => {
			GetTrainSTANewAPI(this.siguids).then(res => {
				if (res) {
					this.alltrainsnumobj = res.data.data;
					this.alltrainsnumobj.trainTime = Math.round(res.data.data.trainTime);
				} else {
				}
			});
		},
		gouserwall() {
			this.$router.push('/datawall/datawalluser');
		},
		changescharts3() {
			let optionper = {
				si_guid: this.siguids,
				month: new Date().getMonth() + 1
			};
			let timer = null;

			GetTrainUsageSTA(optionper).then(res => {
				// console.log(res.data.data, "使用率分析")
				if (res) {
					this.optionsb1.series[0].data[0].value = Math.round((100 - res.data.data) * 100) / 100;
					this.optionsb1.series[0].data[1].value = res.data.data;
					this.myCharts3.setOption(this.optionsb1);
				} else {
					// clearTimeout(timer); //清理定时任务
				}
			});
		},
		getlistyears() {
			let that = this;
			this.datayearname = [];
			this.serieslist = [];
			// GetTrainTimeLengthDataList(this.siguids).then(res => {
			// GetTrainTimeLengthDataListNewApi(this.siguids).then(res => {
			TrainingequipmentTimeApi(this.siguids).then(res => {
				console.log(res, '使用时长分析');
				if (res) {
					that.allistyears = res.data.data;
					if (that.allistyears && that.allistyears.length > 0) {
						that.allistyears.forEach(item => {
							this.datayearname.push(item.te_deviceName);
							this.serieslist.push(item.time);
						});

						this.setcharts();
					}
				}
			});
		},
		// 循环数组得到值
		changelsits(datalistall, pers) {
			var allData = []; //用来装处理完的数组
			var currData = []; //子数组用来存分割完的数据
			//循环需要处理的数组
			for (var i = 0; i < datalistall.length; i++) {
				//将chartArr[i]添加到子数组
				currData.push(datalistall[i]);
				//在这里求4的余数,如果i不等于0,且可以整除 或者考虑到不满4个或等于4个的情况就要加上  i等于当前数组长度-1的时候
				if ((i != 0 && (i + 1) % pers == 0) || i == datalistall.length - 1) {
					//把currData加到allData里
					allData.push(currData);
					//在这里清空currData
					currData = [];
				}
			}
			return allData;
		},

		async setcharts() {
			this.optionsb2.baseOption.xAxis[0].data = this.datayearname;
			this.optionsb2.options[0].series[0].data = this.serieslist;
			this.alltrainsnumobj.trainTime = this.sum(this.serieslist);
			this.myCharts2.setOption(this.optionsb2);
			let isdatascheck1 = await GetDatasyncApi('');
			this.isdatascheck = isdatascheck1.data.data;
			setInterval(() => {
				this.run(this.serieslist);
			}, 4000);
		},
		// 累加数组
		sum(arr) {
			return eval(arr.join('+'));
		},
		// 中间图表信息
		run(data) {
			for (var i = 0; i < data.length; ++i) {
				if (Math.random() > 0.9) {
					data[i] += Math.round(Math.random() * 10);
				} else {
					data[i] += Math.round(Math.random() * 2);
				}
			}
			this.alltrainsnumobj.trainTime = this.sum(data);

			this.optionsb2.options[0].series[0].data = data;
			this.myCharts2.setOption(this.optionsb2);
		},

		dataFormatter(obj) {
			// prettier-ignore
			var pList = ['1月',
					'2月',
					'3月',
					'4月',
					'5月',
					'6月',
					'7月',
					'8月',
					'9月',
					'10月',
					'11月',
					'12月'
				];
			var temp;

			for (var year = 0; year <= this.datayearname.length - 1; year++) {
				var max = 0;
				var sum = 0;
				temp = obj[year];
				for (var i = 0, l = temp.length; i < l; i++) {
					max = Math.max(max, temp[i]);
					sum += temp[i];
					obj[year][i] = {
						name: pList[i],
						value: temp[i]
					};
				}
				obj[year + 'max'] = Math.floor(max / 100) * 100;
				obj[year + 'sum'] = sum;
			}
			return obj;
		},
		getTime() {
			this.timer = setInterval(() => {
				let timeDate = new Date();
				let year = timeDate.getFullYear();
				let mounth = timeDate.getMonth() + 1;
				let day = timeDate.getDate();
				let hours = timeDate.getHours();
				hours = hours >= 10 ? hours : '0' + hours;
				let minutes = timeDate.getMinutes();
				minutes = minutes >= 10 ? minutes : '0' + minutes;
				let seconds = timeDate.getSeconds();
				seconds = seconds >= 10 ? seconds : '0' + seconds;
				let week = timeDate.getDay();
				let weekArr = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];

				this.nowTime = ` ${hours}:${minutes}:${seconds} `;

				this.yeartimer = `${year}/${mounth}/${day}  ${weekArr[week]}`;
			}, 1000);
		}
	},
	components: {
		vueSeamlessScroll,
		numbergrow,
		sacleBox
	}
};
</script>
<style>
.theme-teal {
	background-color: #142131 !important;
}
</style>

<style scoped lang="less">
.scrols {
	ul {
		margin-top: 0 !important;
	}
}

p {
	font-family: '微软雅黑', '微软雅黑 Regular';
}

.nomolflex {
	display: flex;
	align-items: center;
	justify-content: space-between;
	cursor: pointer;
}

.comenteflex {
	display: flex;
	flex-direction: column;
}

.appconten {
	background: url('../../images/datetolines.png') no-repeat center/101% 101%;
	// background-size: 100% auto;
	width: 100%;
	height: 100vh;
	box-sizing: border-box;
	overflow: hidden;
}

.lines {
	height: 100%;
}

.appconten {
	height: 100%;
	display: flex;
	justify-items: space-between;
}

.appleft,
.appright {
	width: 25%;
}

.appright {
	padding: 0 10px;
	height: 100%;
}

.appcenter {
	width: 50%;
	padding: 0 20px;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	flex-direction: column;
}

.trainstitle p {
	color: #fff;
	font-family: '微软雅黑 ', '微软雅黑 Regular';
	// font-weight: 700;
	font-style: normal;
	font-size: 38px;
	color: rgb(205, 221, 247);
	border-width: 0px;
	text-align: center;
	transform: translateY(-76px);
}

.trainstitle {
	width: 100%;
	padding: 20px 0 0 0;
	height: 100px;
	box-sizing: border-box;
}

.trainstitle img {
	width: 105%;
	transform: translateX(-22px);
}

.trainsweather {
	width: 100%;
	height: 12%;
}

.trainsweather .trainsbox {
	border: 1px solid #0e94ea;
	width: 42%;
	height: 100px;
	border-radius: 2px;
	padding: 10px;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-items: first baseline;
}

.trainsweather .trainsboxleft {
	padding: 0 10px;
	// border-right: 1px solid #ffffff;
	width: 100%;
	display: flex;
	align-items: flex-end;
}

.trainsboxright {
	display: flex;
	align-items: center;
	margin-left: 30px;

	p {
		font-size: 1rem;
	}
}

.dataline {
	transform: translateX(-80px);
	height: 80%;
}

.trainsall {
	transform: translateX(-98%);
}

.trainsimg {
	width: 100%;
	height: 88%;
	margin-top: 10px;
	border-radius: 2px;
	/* border: 1px solid #0E94EA; */
}

.trainsimg img {
	width: 100%;
	height: 100%;
	border-radius: 2px;
}

.trainsall p {
	margin: 10px 0;
	font-weight: 700;
	font-style: normal;
	font-size: 18px;
	color: #ffff00;
}

.trainsweather .trainsboxleft p:first-child {
	font-weight: 400;
	font-style: normal;
	font-size: 42px;
	color: #cdddf7;
}

.trainsweather .trainsboxleft p:last-child {
	font-weight: 400;
	font-style: normal;
	font-size: 18px;
	color: rgb(205, 221, 247);
	border-width: 0px;
	margin-bottom: 5px;
}

.appleft {
	padding: 20px;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
}

.applefttitle {
	text-align: center;
	width: 100%;
	height: 18%;
	background: url('../../images/datebig.png') no-repeat center;
	background-size: 100% auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}

.lefttitilefonts {
	color: rgb(14, 148, 234);
	transform: translateY(-10px);
	font-weight: 700;
	font-style: normal;
	font-size: 18px;
}

.fontsanum {
	font-weight: 400;
	font-style: normal;
	font-size: 60px;
	color: #ffffff;

	/deep/ .number-grow {
		font-size: 60px;
		color: #ffffff;
	}
}

.appcenter {
	margin-top: 0.4rem;
}

.appleftcenter {
	width: 100%;
	height: 5%;
}

.appleftcenter img {
	width: 100%;
}

.appleftcenter {
	margin-top: 1rem;
}

.appleftfonts {
	font-family: '幼圆';
	font-weight: 400;
	font-style: normal;
	font-size: 22px;
	color: rgb(255, 255, 255);
	transform: translate(40px, -35px);
}

.applefecharts {
	width: 100%;
	display: flex;
	/* align-items: center; */
	justify-content: flex-start;
}

.applefecharts .echartsm p {
	display: flex;
	align-items: center;
	color: #fff !important;
	margin-top: 30px;
}

.echartsa {
	width: 90%;
	height: 240px;
}

.trainsb {
	height: 24%;
	overflow: hidden;
}

.trainsb ul {
	width: 100%;
	// height: 100%;
	// max-height: 310px;
	// overflow: hidden;
	overflow-y: scroll;
}

.trainsb ul li span {
	margin-right: 10px;
}

.trainsb ul li:nth-of-type(1) p:first-child {
	background-color: #ed405d;
	padding: 10px;
}

.trainsb ul li:nth-of-type(2) p:first-child {
	background-color: #f78c44;
	padding: 10px;
}

.trainsb ul li:nth-of-type(3) p:first-child {
	background-color: #49bcf7;
	padding: 10px;
}

// .trainsb ul li:first-child {
// 	border-bottom: 1px solid #fff;
// }

.trainsb ul::-webkit-scrollbar {
	display: none;
}

.trainsb ul li {
	display: flex;
	width: 100%;
	margin: 10px 0;
	/* border: 1px solid #0E94EA; */
}

.trainsb ul li p {
	width: 33.3%;
	// padding: 10px 0;
	line-height: 30px;
	height: 30px;
	text-align: center;
	// border: 1px solid #0E94EA;
	color: #fff;
	border-bottom: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 1rem;
}

.trainsb ul li p:first-child {
	width: 8% !important;
	background-color: #878787;
}

.trainsb ul li p img {
	width: 30px;
	height: 30px;
	vertical-align: middle;
}

.trainspic2 {
	width: 100%;
	// min-height: 280px;
	// max-height: calc(240px + 100px);
	height: 100%;
	/* border: 1px solid; */
	margin-top: 10px;
}

.trainspic3 {
	height: 100%;
}

.years {
	margin-top: 20px;
	color: #e0e0d8;
	font-size: 20px;
	letter-spacing: 1px;
}

.traingety ul {
	margin-top: 18px;
	overflow: scroll;
}

.traingety ul::-webkit-scrollbar {
	display: none;
}

.traingety li {
	height: 40px;
	text-align: center;
	color: #fff;
	width: 100%;
}

// .traingety li:first-child p {
// 	color: #FFFFED;
// 	font-weight: 700;
// }

// .traingety li:not(li:first-child) {
// 	border-bottom: 1px dashed #ccc;
// }
</style>
